import styled, { css } from 'styled-components';

// Import components
import { Heading } from 'components/elements';

// Import styles
import { ItemDetailsHoverStyle } from 'components/views/vod/components/ItemDetails/styles';
import { media, flex } from 'components/styles';

export const Item = styled.div.attrs(
	({ width, height, image, backgroundSize, itemWithLink }) => ({
		style: {
			width,
			height,
			background: `url(${image}) no-repeat center center`,
			backgroundSize,
			cursor: itemWithLink ? 'pointer' : 'default'
		}
	})
)`
	position: relative;
	text-decoration: none;
	color: initial;
	overflow: hidden;
	display: flex;
	justify-content: center;
	align-items: center;
	&:hover {
		color: initial;
	}

	${ItemDetailsHoverStyle}
`;

export const LinkContainer = styled.div`
	all: unset;
	cursor: pointer;

	${({ isStyledByChildren }) =>
		!isStyledByChildren &&
		css`
			position: absolute;
			width: 100%;
			height: 100%;
			z-index: 6;
		`};
`;

export const Container = styled.div`
	width: 100%;
	${flex({ jc: 'space-between' })};
	padding: 1rem 2rem;

	${media.min.min(css`
		padding: 2.5rem 4.5rem;
	`)}

	${({ borderLine }) =>
		borderLine &&
		css`
			border-bottom: 1px solid rgba(238, 238, 238, 0.22);
			padding: 0.5rem 4.5rem 2rem;
		`}
`;

export const Title = styled(Heading.First)`
	margin: 0;
	font-size: 2.2rem;
	${media.min.min(css`
		font-size: 3.2rem;
	`)};
	color: ${({ theme }) => theme.white};
	z-index: 2;
`;
